import Accordion from 'components/Accordion';
import Link from 'components/Link';
import SectionHeader from 'components/SectionHeader';
import {FC} from 'react';
import {Trans, useTranslation} from 'react-i18next';

const MagicLinkFaq: FC = () => {
    const {t} = useTranslation('Portal');

    return (
        <div className="mt-2 rounded-lg border border-grey-300 bg-white px-6 pb-16 pt-6 shadow-lg">
            <SectionHeader
                classNameTitle="my-2"
                hideHR={true}
                level={2}
                title={t('login.faqTitle')}
            />
            <Accordion
                className="py-2"
                header={t('login.faqQuestion1')}
                isOpenByDefault={true}
            >
                {t('login.faqAnswer1')}
            </Accordion>
            <Accordion className="py-2" header={t('login.faqQuestion2')}>
                <Trans
                    components={[
                        <Link
                            href="https://help.makeleaps.jp/ja/articles/8687205"
                            isOpenInNewTab={true}
                            key={0}
                            rel="noreferrer"
                        >
                            {' '}
                        </Link>,
                        <br key={1} />,
                        <b key={2} />,
                    ]}
                    i18nKey="login.faqAnswer2"
                    t={t}
                />
            </Accordion>
            <Accordion className="py-2" header={t('login.faqQuestion3')}>
                <Trans
                    components={[
                        <br key={0} />,
                        <Link
                            href="https://www.makeleaps.jp/"
                            isOpenInNewTab={true}
                            key={1}
                            rel="noreferrer"
                        >
                            {' '}
                        </Link>,
                    ]}
                    i18nKey="login.faqAnswer3"
                    t={t}
                />
            </Accordion>
            <Accordion className="py-2" header={t('login.faqQuestion4')}>
                <Trans
                    components={[
                        <br key={0} />,
                        <Link
                            href="https://help.makeleaps.jp/ja/articles/8687205"
                            isOpenInNewTab={true}
                            key={1}
                            rel="noreferrer"
                        >
                            {' '}
                        </Link>,
                    ]}
                    i18nKey="login.faqAnswer4"
                    t={t}
                />
            </Accordion>
        </div>
    );
};

export default MagicLinkFaq;
